import { WifiOff, AlertCircle, RefreshCw } from 'lucide-react'

interface ErrorStateProps {
  message?: string
  isOffline?: boolean
  onRetry?: () => void
}

export function ErrorState({ message, isOffline, onRetry }: ErrorStateProps) {
  const Icon = isOffline ? WifiOff : AlertCircle

  return (
    <div className="text-center py-8">
      <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-white/5 flex items-center justify-center">
        <Icon className="w-8 h-8 text-white/30" />
      </div>
      <p className="text-white/50 text-sm mb-4">
        {message || (isOffline ? 'Sem conexão com a internet' : 'Erro ao carregar dados')}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 hover:bg-white/15 text-white/70 text-sm transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          Tentar novamente
        </button>
      )}
    </div>
  )
}
